/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creator_Ext_Device_ConfirmInputs */



/**
* | output |
* | --- |
* | "Yes, enable" |
*
* @param {Creator_Ext_Device_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creator_ext_device_confirm = /** @type {((inputs?: Creator_Ext_Device_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creator_Ext_Device_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Oui, activer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ja, aktivieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sì, abilita")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Да, включить")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sí, habilitar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("是的，启用")
	if (locale === "ja") return /** @type {LocalizedString} */ ("はい、有効にします")
	if (locale === "hi") return /** @type {LocalizedString} */ ("हां, सक्षम करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sim, habilite")
	return /** @type {LocalizedString} */ ("Yes, enable")
});